/** Delivery & Quality — framed (much of its "wow" lives in Reconciliation). */
import React from 'react'
import FramedSurface from './FramedSurface'
import AgingChart from '../components/kit/charts/AgingChart'
import { useTokens } from '../components/kit/charts/useTokens'

export default function Delivery(): React.JSX.Element {
  const t = useTokens()
  const chart = (
    <AgingChart
      buckets={[
        { label: 'Current', value: 0, color: t.green },
        { label: '1–30', value: 180, color: t.cyan },
        { label: '31–60', value: 120, color: t.orange },
        { label: '61–90', value: 64, color: t.orange },
        { label: '90+', value: 38, color: t.bad },
      ]}
    />
  )
  return (
    <FramedSurface
      kicker="Delivery & Quality"
      kickerColor="var(--purple)"
      title="Delivery & Quality"
      desc="OTIF with pinned legacy variants (kirkstall_v1 / oracle_v1 reproduce the live DAX number-for-number), past-due level and movement, and NC/scrap where denominators differ by site — reconciled via registry variants."
      chartTitle="Past-due aging profile"
      chart={chart}
      notes={[
        { h: 'Pinned legacy variants', p: 'kirkstall_v1 / oracle_v1 reproduce the live DAX exactly; as-reported history is never rewritten.' },
        { h: 'Past Due is the drill exemplar', p: 'The metric with a full drill block today (FM + RA + Group-union) — the reconciling walk on the Overview matrix.' },
        { h: 'Site denominators', p: 'NC/Batch denominators differ FM vs RA; the registry variant makes them comparable without overwriting either.' },
      ]}
    />
  )
}
